import{useOnLoadedSuccessByEffect as s}from"./use-on-loaded-success-by-effect.js";import{useOnLoadedSuccessForSsr as c}from"./use-on-loaded-success-for-ssr.js";const f=(e,o,r)=>{s(e,o,r),c(e,o,r)};export{f as useOnLoadedSuccess};
